<template>
    <!-- 协议 弹窗 -->
    <el-dialog
        :visible.sync="visible"
        :append-to-body="true"
        :show-close="false"
        :close-on-click-modal="false"
        width="90%"
        top="50%"
    >
        <p v-html="agreement" />
        <div
            class="agree-wrap"
            @click="handleAgree"
        >
            <img
                v-if="!status"
                src="../../../assets/images/icon_circle.png"
                alt=""
                class="agr-img"
            >
            <img
                v-else
                src="../../../assets/images/icon_circle_checked.png"
                alt=""
                class="agr-img"
            >
            <p class="agr-wrods">{{ language === 'en' ? 'I have read and understood the above':'我已经阅读并理解上述内容' }}</p>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: 'Agreement',
    components: {},
    mixins: [],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        agreement: {
            type: String,
            default: ''
        },
        status: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            language: this.$store.getters.language
        }
    },

    computed: {
    },

    mounted() {
    },

    created() {
    },

    methods: {
        handleAgree() {
            this.$emit('clickAgree')
        }
    }
}
</script>

<style rel="stylesheet/less" lang="less">
.agree-wrap {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .agr-img {
        width: 14px;
        height: 14px;
    }
    .agr-wrods {
        font-size: 14px;
        margin-left: 6px;
    }
}
</style>
